import { formatDate } from 'utils/date'

export const TOGGLE_PREFIX = 'guru-ks-fe-toggle--'
export const TOGGLE_KEYS = {
  PENYESUAIAN_VERVAL_PERIODISASI_ENABLED:
    'penyesuaian-verval-periodisasi-enabled',
  MUTASI_PENGECUALIAN_SATMINKAL_ENABLED:
    'mutasi-pengecualian-satminkal-enabled',
  VERVAL_SK_PPPK_UPT_ENABLED: 'verval-sk-pppk-upt-enabled',
  EDIT_ANNOUNCEMENT_ENABLED: 'edit-announcement-enabled',
  PENCARIAN_PENGAJUAN_PERUBAHAN_ENABLED:
    'pencarian-pengajuan-perubahan-enabled',
  FILTER_PENGAJUAN_PERUBAHAN_ENABLED: 'filter-pengajuan-perubahan-enabled',
  AKSI_PESERTA_DIKLAT_ENABLED: 'aksi-peserta-diklat-enabled',
  DETAIL_VERIFIKASI_SNAPSHOT_ENABLED: 'detail-verifikasi-snapshot-enabled',
}

export const URL_HELPDESK =
  'https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id/categories/52398660479513-SIM-KSPSTK'

export const DEFAULT_ERROR_MESSAGE =
  'Terjadi kesalahan pada sistem. Silahkan coba beberapa saat lagi.'

export const ERROR_MESSAGE_FAILED_UPLOAD = 'Gagal mengunggah file'

export const DATE_CUTOFF_LAPORAN_KEMENDAGRI = '2024-05-02'

export const MSG_LAPORAN_KEMENDAGRI = `Sesuai dengan Surat Edaran Bersama 3 Menteri Nomor 1 Tahun 2024, mulai tanggal ${formatDate(
  DATE_CUTOFF_LAPORAN_KEMENDAGRI
)} seluruh pengangkatan dan rotasi mutasi Kepala Sekolah wajib dilaporkan ke Kemendagri.`
